import {
  CoreApi,
  PinResponse,
  MapCreateRequest,
  MapResponse,
  MapUpdateRequest,
  MapViewBoxRequest,
  MapCentroidResponse,
  MapShapeResponse,
  BlobContentType,
  ImportMapDataRequest,
  IdKeyType,
  MapRequest,
  MapFeatureResponse,
  Boundaries,
  MapPinRequest,
} from "@hokuto/jam-core";
import {
  fetchMapImage,
  fetchMapSvg,
  fetchBlob,
  fetchJSON,
  fetchUpload,
  SearchViewBoxApi,
} from "./fetch.js";
import { ApiMethod } from "../types.js";
import { getMapImageUrl } from "./url.js";

export const MapApi = {
  Search: new SearchViewBoxApi<MapRequest, MapResponse, MapFeatureResponse>(
    CoreApi.Map.Search
  ),
  Create: fetchJSON<MapCreateRequest, MapResponse>(
    CoreApi.Map.Create,
    ApiMethod.Post
  ),
  Read: fetchJSON<MapRequest, MapResponse>(CoreApi.Map.Read),
  Update: fetchJSON<MapUpdateRequest, MapResponse>(
    CoreApi.Map.Update,
    ApiMethod.Put
  ),
  Delete: fetchJSON<MapRequest>(CoreApi.Map.Delete, ApiMethod.Delete),
  Clone: fetchJSON<MapRequest, MapResponse>(CoreApi.Map.Clone, ApiMethod.Post),
  Export: fetchBlob<MapRequest>(CoreApi.Map.Export, BlobContentType.Json),
  Import: fetchUpload<ImportMapDataRequest, { [IdKeyType.Map]: string }>(
    CoreApi.Map.Import
  ),
  Centroid: fetchJSON<MapViewBoxRequest, MapCentroidResponse>(
    CoreApi.Map.Centroid
  ),
  Image: fetchMapImage(CoreApi.Map.Image),
  ImageUrl: getMapImageUrl(CoreApi.Map.Image),
  Label: fetchMapImage(CoreApi.Map.Label),
  LabelUrl: getMapImageUrl(CoreApi.Map.Label),
  Pin: fetchJSON<MapPinRequest, PinResponse>(CoreApi.Map.Pin),
  ViewBox: fetchJSON<MapViewBoxRequest, Boundaries>(CoreApi.Map.ViewBox),
  Shape: fetchJSON<MapViewBoxRequest, MapShapeResponse>(CoreApi.Map.Shape),
  Svg: fetchMapSvg(CoreApi.Map.Svg),
};
